import URI from 'jsuri';

import type { EntityType } from 'bundles/unified-seo-content-common/types';
import { getEntityTypeFromEntityPathName } from 'bundles/unified-seo-content-common/utils';

type EntityParams = {
  slug: string;
  entityType: EntityType;
};

const getEntityParamsFromUrl = (URL: string): EntityParams => {
  const entityUri = new URI(URL);
  const [, entityPathName, slug] = entityUri.path().toString().split('/');
  const entityType = getEntityTypeFromEntityPathName(entityPathName);

  return {
    slug,
    entityType,
  };
};

export default getEntityParamsFromUrl;
